/* SKY product rows: drag, pause control, keyboard pause, and a single
   IntersectionObserver so only rows in the viewport animate. */
(() => {
  if (window.skyRowsInit) return; window.skyRowsInit = true;
  const init = () => {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const rows = document.querySelectorAll('[data-sky-row]');
    const io = new IntersectionObserver((es) =>
      es.forEach((e) => e.target.classList.toggle('is-live', e.isIntersecting)));
    rows.forEach((row) => {
      io.observe(row);
      const vp = row.querySelector('.sky-pr__viewport'), tr = row.querySelector('.sky-pr__track');
      const btn = row.querySelector('.sky-pr__pp');
      let start = null, dragging = false, off = 0, off0 = 0, moved = false;
      const setW = () => tr.scrollWidth / 2;
      const cur = () => -(new DOMMatrixReadOnly(getComputedStyle(tr).transform).m41);
      // the sim rail is a native snap scroller at EVERY width now: the
      // transform-based drag below must never touch it (that fight is what
      // parked the rail mid-card).
      const manual = () => row.classList.contains('sky-sim');
      vp.addEventListener('pointerdown', (e) => { if (manual()) return; start = { x: e.clientX, id: e.pointerId }; moved = false; });
      vp.addEventListener('pointermove', (e) => {
        if (!start) return;
        const dx = start.x - e.clientX;
        if (!dragging && Math.abs(dx) > 5) {
          dragging = true; off0 = cur(); tr.classList.add('is-drag');
          try { vp.setPointerCapture(start.id); } catch (_) {}
        }
        if (dragging) {
          const w = setW();
          off = (((off0 + dx) % w) + w) % w;
          tr.style.transform = 'translateX(' + (-off) + 'px)';
          moved = true;
        }
      });
      const up = () => {
        if (dragging) {
          tr.style.animation = 'none'; void tr.offsetWidth;
          tr.style.animation = '';
          const durS = parseFloat(getComputedStyle(tr).animationDuration) || 45;
          tr.style.animationDelay = (-(off / setW()) * durS) + 's';
          tr.style.transform = ''; tr.classList.remove('is-drag');
        }
        start = null; dragging = false;
      };
      vp.addEventListener('pointerup', up);
      vp.addEventListener('pointercancel', up);
      vp.addEventListener('focusout', () => requestAnimationFrame(() => {
        if (!manual() && !vp.contains(document.activeElement)) vp.scrollLeft = 0;
      }));
      vp.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      if (btn) btn.addEventListener('click', () => {
        const p = tr.classList.toggle('is-paused');
        btn.setAttribute('aria-pressed', p); btn.textContent = p ? 'Play' : 'Pause';
        btn.setAttribute('aria-label', p ? 'Resume auto-scroll' : 'Pause auto-scroll');
      });
      // Owner-ruled stepped auto-advance, mobile sim rail only: one card per
      // tick via the scroller's own scrollTo, so motion shares the native
      // scroll channel and cannot fight snap or the finger. Killed on touch,
      // resumed after 6s idle. The transform marquee is never restored here.
      if (row.classList.contains('sky-sim')) {
        let tick = null, resume = null;
        const pad = () => parseFloat(getComputedStyle(vp).scrollPaddingLeft) || 0;
        const stops = () => {
          const vr = vp.getBoundingClientRect();
          const set = row.querySelector('.sky-pr__set:not([aria-hidden="true"])');
          if (!set) return [];
          const max = vp.scrollWidth - vp.clientWidth;
          const p = pad();
          const s = [...set.querySelectorAll('.sky-pr__card')]
            .map((c) => Math.round(c.getBoundingClientRect().left - vr.left + vp.scrollLeft - p))
            .filter((x) => x >= 0 && x <= max - 1);
          s.push(max);
          return s;
        };
        const step = () => {
          if (!row.classList.contains('is-live') ||
              document.visibilityState !== 'visible' || tr.classList.contains('is-paused')) return;
          const s = stops(); if (!s.length) return;
          const cur = vp.scrollLeft;
          const next = s.find((x) => x > cur + 2);
          vp.scrollTo({ left: next === undefined ? 0 : next, behavior: 'smooth' });
        };
        const stop = () => { clearInterval(tick); tick = null; clearTimeout(resume); resume = null; };
        const play = () => { if (!tick) tick = setInterval(step, 4000); };
        const idle = () => { clearTimeout(resume); resume = setTimeout(play, 6000); };
        vp.addEventListener('touchstart', stop, { passive: true });
        vp.addEventListener('touchend', idle, { passive: true });
        vp.addEventListener('touchcancel', idle, { passive: true });
        vp.addEventListener('pointerdown', stop);
        vp.addEventListener('pointerup', idle);
        // desktop mouse: hover pauses like the old marquee did, and grab-drag
        // moves the SCROLLER (never the track transform); release snaps to
        // the nearest card stop so a drag cannot park the rail mid-card.
        vp.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') stop(); });
        vp.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') idle(); });
        let mx = null, msl = 0, mMoved = false;
        vp.addEventListener('pointerdown', (e) => {
          if (e.pointerType !== 'mouse') return;
          mx = e.clientX; msl = vp.scrollLeft; mMoved = false;
        });
        vp.addEventListener('pointermove', (e) => {
          if (mx === null || e.pointerType !== 'mouse') return;
          const dx = mx - e.clientX;
          if (!mMoved && Math.abs(dx) > 5) {
            mMoved = true;
            try { vp.setPointerCapture(e.pointerId); } catch (_) {}
          }
          if (mMoved) vp.scrollLeft = msl + dx;
        });
        const mup = () => {
          if (mx === null) return;
          mx = null;
          if (mMoved) {
            const s = stops(); const cur = vp.scrollLeft;
            if (s.length) {
              const near = s.reduce((a, b) => Math.abs(b - cur) < Math.abs(a - cur) ? b : a);
              vp.scrollTo({ left: near, behavior: 'smooth' });
            }
          }
          idle();
        };
        vp.addEventListener('pointerup', mup);
        vp.addEventListener('pointercancel', mup);
        vp.addEventListener('click', (e) => {
          if (mMoved) { e.preventDefault(); e.stopPropagation(); mMoved = false; } }, true);
        document.addEventListener('visibilitychange', () => {
          document.visibilityState === 'visible' ? play() : stop(); });
        if (btn) btn.addEventListener('click', () => {
          tr.classList.contains('is-paused') ? stop() : play(); });
        play();
      }
    });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
